module.exports = __webpack_public_path__ + "static/media/enhanced-grain-smokedoak.9caff4ea.png";